import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=b3c4bc8c&lang=scss&scoped=true"

import exportComponent from "/Users/ioblabs/work/weina/production/weina_oms_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3c4bc8c"]])

export default __exports__